import { render, staticRenderFns } from "./TDelimiter.vue?vue&type=template&id=62b47194&scoped=true&"
import script from "./TDelimiter.vue?vue&type=script&lang=js&"
export * from "./TDelimiter.vue?vue&type=script&lang=js&"
import style0 from "./TDelimiter.vue?vue&type=style&index=0&id=62b47194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b47194",
  null
  
)

export default component.exports